import PrimeCarouselPagination from './PrimeCarouselPagination.js';
import '../../stylus/prime-carousel-preview-pagination.styl';

export default PrimeCarouselPagination.extend({
    name: 'PrimeCarouselPreviewPagination',
    props: {
        rawItems: {},
    },
    data() {
        return {
            itemsContainerTopOffset: 0,
            thumbnailInnerHeight: 93,
            thumbnailInnerWidth: 65,
            paginationContainerCalculatedHeight: null,
            thumbnailMargin: 10,
        };
    },
    computed: {
        thumbnailOuterHeight() {
            return this.thumbnailInnerHeight + (2 * this.thumbnailMargin);
        },
        thumbnailOuterWidth() {
            return this.thumbnailInnerWidth + (2 * this.thumbnailMargin);
        },
        paginationContainerHeight() {
            let height;
            if (this.paginationContainerCalculatedHeight) {
                height = `${this.paginationContainerCalculatedHeight}px`;
            } else {
                const prevBtnHeight = this.$refs.prevBtn ? this.$refs.prevBtn.$el.offsetHeight : 0;
                const nextBtnHeight = this.$refs.nextBtn ? this.$refs.nextBtn.$el.offsetHeight : 0;
                height = `calc(100% - ${prevBtnHeight}px - ${nextBtnHeight}px)`;
            }
            return height;
        },
    },
    methods: {
        setupHeight(height) {
            if (height % this.thumbnailOuterHeight) {
                const prevBtnHeight = this.$refs.prevBtn ? this.$refs.prevBtn.$el.offsetHeight : 0;
                const nextBtnHeight = this.$refs.nextBtn ? this.$refs.nextBtn.$el.offsetHeight : 0;
                const heightPerItem = (height - prevBtnHeight - nextBtnHeight) / this.thumbnailOuterHeight;
                const intHeightPerItem = Math.floor(heightPerItem);
                this.paginationContainerCalculatedHeight = intHeightPerItem * this.thumbnailOuterHeight;

                this.$nextTick(() => {
                    if (this.value + 1 !== this.carouselItems.length) {
                        this.itemsContainerTopOffset = -this.value * this.thumbnailOuterHeight;
                    }
                });
            }
        },
        genItems(h) {
            return this.carouselItems.map((i, index) => {
                return h(
                    'li',
                    {
                        key: index,
                        style: {
                            width: this.thumbnailOuterWidth + 'px',
                            height: this.thumbnailOuterHeight + 'px',
                            padding: this.thumbnailMargin + 'px',
                        },
                    },
                    [
                        this.genItem(h, i, this.getSize(i)),
                    ],
                );
            });
        },
        genItem(h, i, size) {
            return h(
                'v-img',
                {
                    props: {
                        src: this.getItemImageSource(this.rawItems[i]),
                    },
                    style: {
                        width: '100%',
                        height: '100%',
                        'border-radius': 0,
                        opacity: i === this.value ? 1 : '.5',
                        cursor: 'pointer',
                    },
                    on: {
                        click: () => {
                            return this.$emit('input', i);
                        },
                    },
                },
            );
        },
        genBeforeItems(h) {
            return h(
                'v-btn',
                {
                    props: {
                        icon: true,
                        light: true,
                        disabled: this.value === 0,
                    },
                    class: 'ma-0',
                    ref: 'prevBtn',
                },
                [
                    h(
                        'v-icon',
                        {
                            on: {
                                click: () => {
                                    this.$emit('input', this.value - 1);
                                },
                            },
                        },
                        [
                            'keyboard_arrow_up',
                        ],
                    ),
                ],
            );
        },
        genAfterItems(h) {
            return h(
                'v-btn',
                {
                    props: {
                        icon: true,
                        light: true,
                        disabled: this.value + 1 >= this.carouselItems.length,
                    },
                    class: 'ma-0',
                    ref: 'nextBtn',
                },
                [
                    h(
                        'v-icon',
                        {
                            on: {
                                click: () => {
                                    if (this.value + 1 < this.carouselItems.length) {
                                        this.$emit('input', this.value + 1);
                                    }
                                },
                            },
                        },
                        [
                            'keyboard_arrow_down',
                        ],
                    ),
                ],
            );
        },
        getItemImageSource(itemComponent) {
            let src = null;

            if (itemComponent.src) {
                src = itemComponent.src;
            } else if (itemComponent.$children) {
                for (let child of itemComponent.$children) {
                    src = this.getItemImageSource(child);

                    if (src) {
                        break;
                    }
                }
            }

            return src;
        },
    },
    render(h) {
        let children = [this.genItems(h)];

        return h(
            'ul',
            {
                directives: [
                    {
                        modifiers: { quiet: true },
                        name: 'resize',
                        value: this.onResize,
                    },
                ],
                class: {
                    ...this.classes,
                    'prime-carousel-pagination': true,
                    'layout column align-center justify-space-between fill-height ma-0 text-center': true,
                },
            },
            [
                this.genBeforeItems(h),
                h(
                    'div',
                    {
                        class: 'prime-carousel-pagination-container',
                        style: {
                            height: this.paginationContainerHeight,
                            width: this.thumbnailOuterWidth + 'px',
                        },
                        ref: 'paginationContainer',
                    },
                    [
                        h(
                            'div',
                            {
                                class: 'prime-carousel-pagination-items-container',
                                style: {
                                    top: this.itemsContainerTopOffset + 'px',
                                },
                                ref: 'paginationItemsContainer',
                            },
                            [
                                children,
                            ],
                        ),
                    ],
                ),
                this.genAfterItems(h),
            ],
        );
    },
    watch: {
        setupComplete(val) {
            if (val) {
                this.$emit('render-complete', this);
            }
        }
    }
});